export default class APIError extends Error {
  statusCode: number;
  subCode?: string;
  requestId?: string;

  constructor(message: string, statusCode: number, subCode?: string, requestId?: string) {
    super(message);
    Object.setPrototypeOf(this, APIError.prototype); // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#example

    this.statusCode = statusCode;
    this.subCode = subCode;
    this.requestId = requestId;
  }
}

/**
 * Duck-type check for APIError shape. `instanceof` can fail across
 * module boundaries during Vite HMR, so we also check for the
 * `statusCode` property that only APIError carries.
 */
export function asAPIError(error: unknown): APIError | null {
  if (error instanceof APIError) return error;
  if (
    error instanceof Error &&
    'statusCode' in error &&
    typeof (error as APIError).statusCode === 'number'
  ) {
    return error as APIError;
  }
  return null;
}
